import { render, staticRenderFns } from "./InvoiceTypeIndex.vue?vue&type=template&id=1452be54&scoped=true&"
import script from "./InvoiceTypeIndex.vue?vue&type=script&lang=js&"
export * from "./InvoiceTypeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1452be54",
  null
  
)

export default component.exports